var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[(!_vm.error)?_c('v-col',{attrs:{"align":"center"}},[_c('b',[_vm._v("Loading...")])]):_vm._e(),(_vm.error)?_c('v-col',{attrs:{"align":"center"}},[_c('b',[_vm._v("There was an error getting the access token. :(")])]):_vm._e(),_c('v-row')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }